import { FC } from "react";

interface FooterButtonProps {
  children: string;
  className?: string;
  onClick: () => void;
}

const FooterButton: FC<FooterButtonProps> = ({ onClick, className = "" }) => (
  <svg
    className={className}
    width="292"
    height="102"
    viewBox="0 0 292 102"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path d="M0 22L14 4L13.7358 22H0Z" fill="#B28241" />
    <g clipPath="url(#clip0_3972_9619)">
      <rect
        x="12.3279"
        width="278.906"
        height="102"
        rx="9.5625"
        fill="#FFDEAD"
      />
      <path
        d="M165.024 0H291.234V100.406H125.484L165.024 0Z"
        fill="url(#paint0_linear_3972_9619)"
      />
      <path
        d="M120.751 50.2141H112.183V39.4659H118.724V36.6736H88.889V39.4659H95.927V49.3344V50.2141H86.9V53.0064H95.8505C95.5062 59.3559 93.8997 62.3011 88.277 67.0824L90.4572 69.2244C96.4625 63.9076 98.4132 60.5416 98.834 53.0064H109.123V68.5359H112.183V53.0064H120.751V50.2141ZM98.9487 50.2141V49.0284V39.4659H109.123V50.2141H98.9487ZM133.426 42.3729C132.508 40.4221 130.137 36.6354 128.722 34.9906L126.58 36.3676C127.88 38.0889 130.252 41.9139 131.131 44.1706L133.426 42.3729ZM145.934 41.6844C144.136 40.5369 142.033 39.3129 140.617 38.5861L139.24 40.4986C140.579 41.1871 142.492 42.3346 144.175 43.5586H135.913V62.7601H138.514V57.0226H144.442V62.3394H147.005V57.0226H153.087V58.2084C153.087 59.8149 152.896 60.2356 151.136 60.3886L149.262 60.5416L150.065 63.0661L151.595 62.9131C154.693 62.6071 155.688 61.8421 155.688 59.2411V43.5586H148.038L148.229 43.2909L148.153 43.2144C150.639 41.7609 153.125 40.0014 155.611 38.2036V35.9086H135.874V38.2801H151.098C149.415 39.5041 147.694 40.6899 145.934 41.6844ZM144.442 46.0066V49.1431H138.514V46.0066H144.442ZM153.087 49.1431H147.005V46.0066H153.087V49.1431ZM141.459 64.7874C136.295 64.5196 133.35 63.2574 131.59 60.0061V47.0011H124.552V49.8316H128.836V60.1209C126.886 62.1864 125.815 63.1044 123.711 64.8639L125.547 67.3884C127.498 65.5141 129.142 63.8311 130.328 62.5306C132.547 65.7819 135.607 67.2354 141.038 67.4649C146.393 67.6944 153.202 67.6561 158.557 67.4266L159.092 64.7491C153.699 65.0169 146.852 65.0551 141.459 64.7874ZM138.514 54.6511V51.5529H144.442V54.6511H138.514ZM147.005 54.6511V51.5529H153.087V54.6511H147.005ZM169.969 64.7874H174.253L183.395 38.2419H179.914L172.341 61.1536H172.111L164.653 38.2419H160.981L169.969 64.7874ZM187.495 64.7874H190.938V38.2419H187.495V64.7874ZM197.991 64.7874H201.434V55.3779H205.374C212.259 55.3779 215.089 52.9681 215.089 46.7334C215.089 40.8429 212.871 38.2419 205.374 38.2419H197.991V64.7874ZM201.434 52.5091V41.2254H205.068C210.002 41.2254 211.57 42.6789 211.57 46.7334C211.57 51.2086 210.002 52.5091 205.068 52.5091H201.434Z"
        fill="#B28241"
      />
    </g>
    <rect
      x="13.1248"
      y="0.796875"
      width="277.312"
      height="100.406"
      rx="8.76562"
      stroke="#B28241"
      strokeWidth="1.59375"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3972_9619"
        x1="127.881"
        y1="86.0625"
        x2="294.713"
        y2="65.5762"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD69A" />
        <stop offset="1" stopColor="#FFD28F" />
      </linearGradient>
      <clipPath id="clip0_3972_9619">
        <rect
          x="12.3279"
          width="278.906"
          height="102"
          rx="9.5625"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export default FooterButton;
